import { render, staticRenderFns } from "./MapIdeaBlock.vue?vue&type=template&id=461a6b72&scoped=true&"
import script from "./MapIdeaBlock.vue?vue&type=script&lang=js&"
export * from "./MapIdeaBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a6b72",
  null
  
)

export default component.exports